{
  "general": {
    "copyright": "Laurent Chicoine Productions © 2022 Tous droits réservés.",
    "privacy": "Politique de confidentialité",
    "tos": "Conditions d'utilisation"
  },
  "form": {
    "blank": "[Vide]"
  },
  "user": {
    "displayName": "Nom",
    "submit": "Enregistrer",
    "login-title": "Connexion",
    "register": "S'inscrire",
    "forgot-password": "Mot de passe oublié",
    "email": "Courriel",
    "password": "Mot de passe",
    "password-again": "Confirmer le mot de passe",
    "forgot-password-question": "Mot de passe oublié?",
    "fullname": "Nom complet",
    "login-button": "Connexion",
    "register-button": "S'inscrire",
    "reset-password-button": "Réinitialiser",
    "set-password-button": "Soumettre",
    "buy": "ACHETER",
    "username": "Nom d'utilisateur",
    "code": "Code de réinitialisation",
    "teams": "Équipes",
    "add-new-user": "Ajouter un membre",
    "reset-password": "Réinitialiser le mot de passe",
    "set-password": "Configurer le mot de passe"
  },
  "configuration": {
    "cameras": "Caméras",
    "recordingSetups": "Profils d'enregistrement",
    "integrationAccounts": "Comptes d'intégration",
    "recorders": "Enregistreurs"
  },
  "recordingSetup": {
    "name": "Nom",
    "active": "Actif",
    "inactive": "Inactif",
    "status-filter-label": "Statut",
    "camera": "Caméra",
    "endzoneCamera": "Caméra de zone des buts",
    "endzoneCamera2": "Caméra de zone des buts 2",
    "detectionMode": "Mode de détection",
    "endzoneDetectionMode": "Mode de détection de zone des buts",
    "endzoneDetectionMode2": "Mode de détection de zone des buts 2",
    "submit": "Enregistrer",
    "detectionAreas": "Zones de détection",
    "mainAreas": "Zones principales",
    "endzoneMainAreas": "Zones principales de zone des buts",
    "endzoneMainAreas2": "Zones principales de zone des buts 2",
    "teams": "Disponible pour les équipes",
    "fixedTilt": "Configuration inclinaison fixe",
    "useFixedTilt": "Utiliser l'inclinaison fixe",
    "fixedTiltMiddleAdjustment": "Ajustement pour baisser l'inclinaison au milieu (en mètres)",
    "fixedTiltEdgeAdjustment": "Ajustement pour baisser l'inclinaison sur les côtés (en mètres)",
    "encodingCodec": "Codec d'encodage",
    "lowQuality": "Économiseur de données (moins bonne qualité)",
    "saveOriginal": "Récupérer les videos originaux",
    "includeScoreboard": "Afficher le tableau de bord sur le flux en direct",
    "includeScoreboardInVideoTool": "Afficher le tableau de bord dans l'outil vidéo"
  },
  "camera": {
    "name": "Nom",
    "active": "Actif",
    "inactive": "Inactif",
    "status-filter-label": "Statut",
    "cameraModel": "Modèle de caméra",
    "fieldType": "Type de terrain",
    "orientation": "Orientation",
    "scoreboardType": "Type de tableau de bord",
    "fieldAnnotations": "Annotations de terrain",
    "rawAnnotations": "Limite brute du tableau de bord",
    "scoreboardAnnotations": "Annotations du tableau de bord aplati",
    "detectionFieldAnnotations": "Annotations de détection sur le terrain",
    "snapshot": "Capture d'écran",
    "virtualCamera": "Configuration de la caméra virtuelle",
    "virtualWidth": "Largeur virtuelle",
    "virtualHeight": "Hauteur virtuelle",
    "panoFOV": "FOV panoramique (radian)",
    "verticalScale": "Échelle verticale",
    "rotationFormula": "Formule de rotation",
    "hasAudio": "Possède un son",
    "audioHighPassFilter": "Filtre passe-haut audio",
    "audioLowPassFilter": "Filtre passe-bas audio",
    "audioGain": "Gain audio (db)",
    "usePCMAudio": "Utilise le format audio PCM",
    "useFilePacks": "Utiliser le téléchargement de fichiers",
    "minBitrate": "Débit binaire minimal",
    "maxBitrate": "Débit binaire maximal",
    "minFocal": "Focale minimale",
    "camera": "Configuration de la caméra",
    "resolutionWidth": "Largeur",
    "resolutionHeight": "Hauteur",
    "teams": "Disponible pour les équipes",
    "fps": "Fréquence d'images",
    "gop": "Intervalles d'images I",
    "rtspPort": "Port RTSP",
    "port": "Port HTTP",
    "channel": "Canal",
    "cameraMap": "Carte de la caméra",
    "cameraMapMode": "Mode de la carte",
    "multiband": "Fusion multibande",
    "calibration": "Calibration (lentille et rotation par capteur, JSON)",
    "calibrationInvalid": "La calibration n'est pas un objet JSON valide.",
    "calibrationRequired": "Une caméra paramétrique doit avoir une calibration.",
    "calibrationNoSensors": "La calibration n'a aucun capteur : « sensors » doit être un objet non vide.",
    "calibrationSensorNotObject": "Calibration : le capteur « {{sensor}} » doit être un objet.",
    "calibrationSensorInvalid": "Calibration, capteur « {{sensor}} » : « {{field}} » doit être {{expected}}.",
    "calibrationOrderInvalid": "Calibration : « order » doit être une liste nommant chaque capteur une seule fois.",
    "calibrationExpectedPositivePair": "deux nombres supérieurs à 0",
    "calibrationExpectedPositive": "un nombre supérieur à 0",
    "calibrationExpectedNumber": "un nombre",
    "calibrationExpectedLens": "un objet contenant f, k1, k2, k3, cx et cy",
    "calibrationExpectedRotation": "trois nombres (vecteur de Rodrigues)",
    "calibrationExpectedRect": "quatre nombres, ou null",
    "calibrationExpectedModel": "l'une des valeurs angle, rectilinear, cylinder",
    "calibrationExpectedTrack": "un entier supérieur ou égal à 0",
    "rawSnapshotOf": "Image brute {{index}} de {{count}} (de gauche à droite)",
    "scoreboardRawIndex": "Image brute contenant le tableau de bord",
    "sectionProjection": "Projection",
    "sectionMap": "Carte",
    "sectionOutput": "Sortie",
    "fullCameraMap": "Carte complète de la caméra",
    "ipAddress": "Adresse IP",
    "iperfIp": "Adresse IP IPerf",
    "rtspCacheName": "Nom du cache RTSP",
    "ownerOrganization": "Organisation propriétaire",
    "FOVRange": "FOV minimum / maximum (radian)",
    "panoWidth": "Largeur de la panoramique à 360°",
    "panoHeight": "Hauteur de la panoramique à 180°",
    "panoXTranslation": "Découpe de la carte X",
    "panoYTranslation": "Découpe de la carte Y",
    "panoType": "Projection de la panoramique",
    "detectionCamera": "Configuration de la caméra de détection",
    "recorder": "Enregistreur",
    "submit": "Enregistrer",
    "userName": "Utilisateur",
    "userPassword": "Mot de passe utilisateur",
    "ptzDataDelay": "Délai entre l'enregistrement et la PTZ (ms)",
    "ptzMode": "Mode de mouvement PTZ",
    "videoSaveDelay": "Délai entre l'enregistrement et le flux RTSP en direct (ms)",
    "applyPTZSlide": "Le panorama a une rotation de 180°",
    "generateDetectionMap": "Générer une carte de détection",
    "antiAliasRatio": "Ratio anti-aliasing",
    "start-ptz-calib": "Débuter la calibration PTZ",
    "start-focus-calib": "Débuter la calibration du Focus"
  },
  "orientation":{
    "vertical": "Vertical",
    "horizontal": "Horizontal"
  },
  "scoreboard": {
    "scoreboard": "Tableau de bord",
    "localScore": "Score local",
    "awayScore": "Score à l'extérieur",
    "gameClock": "Horloge du match",
    "localScore1": "Score local - Chiffre 1",
    "localScore2": "Score local - Chiffre 2",
    "awayScore1": "Score à l'extérieur - Chiffre 1",
    "awayScore2": "Score à l'extérieur - Chiffre 2",
    "gameClock1": "Horloge du match - Chiffre 1",
    "gameClock2": "Horloge du match - Chiffre 2",
    "gameClock3": "Horloge du match - Séparateur",
    "gameClock4": "Horloge du match - Chiffre 3",
    "gameClock5": "Horloge du match - Chiffre 4",
    "awayPenalty1Minutes": "Pénalité à l'extérieur 1 - Minutes",
    "awayPenalty1Seconds": "Pénalité à l'extérieur 1 - Secondes",
    "awayPenalty1Seconds1": "Pénalité à l'extérieur 1 - Secondes, chiffre 1",
    "awayPenalty1Seconds2": "Pénalité à l'extérieur 1 - Secondes, chiffre 2",
    "awayPenalty2Minutes": "Pénalité à l'extérieur 2 - Minutes",
    "awayPenalty2Seconds": "Pénalité à l'extérieur 2 - Secondes",
    "awayPenalty2Seconds1": "Pénalité à l'extérieur 2 - Secondes, chiffre 1",
    "awayPenalty2Seconds2": "Pénalité à l'extérieur 2 - Secondes, chiffre 2",
    "localPenalty1Minutes": "Pénalité locale 1 - Minutes",
    "localPenalty1Seconds": "Pénalité locale 1 - Secondes",
    "localPenalty1Seconds1": "Pénalité locale 1 - Secondes, chiffre 1",
    "localPenalty1Seconds2": "Pénalité locale 1 - Secondes, chiffre 2",
    "localPenalty2Minutes": "Pénalité locale 2 - Minutes",
    "localPenalty2Seconds": "Pénalité locale 2 - Secondes",
    "localPenalty2Seconds1": "Pénalité locale 2 - Secondes, chiffre 1",
    "localPenalty2Seconds2": "Pénalité locale 2 - Secondes, chiffre 2",
    "period": "Période",
    "down": "Down",
    "distance": "Distance",
    "yardLine": "Ligne des yards",
    "full": "Zone du tableau de bord",
    "overrideLocalScore": "Remplacer le score local",
    "overrideAwayScore": "Remplacer le score à l'extérieur",
    "overridePeriod": "Remplacer la période",
    "disableClock": "Désactiver l'horloge du match",
    "disableScoreboard": "Désactiver le tableau de bord"
  },
  "integrationAccount": {
    "name": "Nom",
    "type": "Type",
    "password": "Mot de passe",
    "email": "Courriel",
    "username": "Nom d'utilisateur",
    "submit": "Enregistrer",
    "authorization": "Autorisation",
    "authorize": "Autoriser",
    "revoke": "Révoquer",
    "teams": "Disponible pour les équipes",
    "revoke-message-youtube": "La révocation de l'accès supprimera également toutes les données de l'application associées à ce compte YouTube. Êtes-vous sûr de vouloir révoquer l'accès ?"
  },
  "team": {
    "name": "Nom",
    "hockeyTVTeamId": "ID d'équipe HockeyTV",
    "hudlTeamId": "ID d'équipe Hudl",
    "vidswapTeamId": "ID d'équipe VidSwap",
    "rseqTeamId": "ID d'équipe RSEQ",
    "spordleId": "ID Spordle",
    "spordleUrl": "URL Spordle",
    "organization": "Organisation",
    "scoreboardTemplate": "Modèle de tableau de bord",
    "sport": "Sport",
    "level": "Catégorie",
    "submit": "Enregistrer",
    "youtubeAccount": "Compte YouTube",
    "hudlAccount": "Compte Hudl",
    "vidswapAccount": "Compte VidSwap",
    "videoTool": "Outil vidéo",
    "replayApiKey": "Clé API Replay",
    "replayApiKeyHelp": "Active Replay pour cette équipe. Les matchs incluent Replay par défaut; les autres enregistrements peuvent l'activer.",
    "replayApiKeyPlaceholder": "Clé API de l'équipe Replay",
    "internalVideoRetentionDays": "Conservation des vidéos internes (jours)",
    "internalVideoRetentionDaysHelp": "Les enregistrements internes sont automatiquement supprimés ce nombre de jours après leur date d'enregistrement. Seul un administrateur peut modifier cette valeur.",
    "iCalUrl": "Lien public ICal",
    "iCalLocations": "Sélectionner les emplacements avec enregistrement automatique",
    "gender": "Genre",
    "liveStreamPrefix": "Préfixe du titre de la diffusion en direct",
    "liveStreamThumbnail": "Vignette de la diffusion en direct (.png ou .jpg 2 Mo max)",
    "isLocation": "Utiliser comme emplacement (équipe générique)",
    "members": "Membres",
    "membersWrite": "Membres avec accès à planifier des enregistrements et modifier l'équipe",
    "calendarSyncs": "Synchronisations d'horaires",
    "defaultHudlShare": "Partage par défaut sur Hudl",
    "liveStreamProvider": "Fournisseur de diffusion en direct",
    "get-video-sharing-link": "Copier le lien de partage de vidéo"
  },
  "calendarSync": {
    "type": "Type de synchronisation",
    "iCalUrl": "URL iCal",
    "location": "Endroit",
    "locationRequired": "L'endroit est requis pour la synchronisation de dépistage adverse",
    "opponentScout": "Dépistage adverse (autres matchs au terrain local)",
    "opponentScoutHint": "Synchronise les matchs de la ligue joués à l'endroit où l'équipe ne joue pas, en tant que dépistage",
    "remove": "Supprimer",
    "startOffset": "Début différé (minutes)",
    "endOffset": "Fin différée (minutes)",
    "iCalRegexCaseInsensitive": "Non-sensible à la case",
    "iCalRegex": "Regex du nom de l'événement",
    "youtubePlaylist": "Liste de lecture YouTube",
    "liveUnlistAfterEnd": "Changer YouTube à non-listé après la diffusion",
    "syncToVideoTool": "Synchroniser à l'outil vidéo",
    "syncToVideoToolType": "Parties à synchroniser",
    "videoToolPrefix": "Préfix à ajouter dans l'outil vidéo",
    "home-games": "Receveur",
    "all-games": "Toutes"
  },
  "organization": {
    "name": "Nom",
    "teamName": "Nom des équipes de sport",
    "mainColor": "Couleur principale de l'équipe",
    "rseqOrganizationId": "ID de l'institution RSEQ",
    "spordleOfficeId": "ID d'office Spordle",
    "language": "Langue",
    "logo": "Logo",
    "replaceLogoColor": "Remplacer la couleur principale du logo",
    "scoreboardName": "Nom sur le tableau de bord de la diffusion en direct",
    "submit": "Enregistrer",
    "timezone": "Fuseau horaire",
    "enabled": "Activée",
    "members": "Membres",
    "admins": "Administrateurs de l'organisation",
    "recordingSummaryRecipients": "Destinataires du rapport d'utilisation hebdomadaire des caméras"
  },
  "menu": {
    "app": "Accueil",
    "team": "Gestion",
    "cameras": "Caméras",
    "recordingSetups": "Profils d'enregistrement",
    "integrationAccounts": "Comptes d'intégration",
    "manage-team-members": "Gérer les membres",
    "manage-teams": "Gérer les équipes",
    "manage-organizations": "Gérer les organisations",
    "manage-my-organization": "Gérer mon organization",
    "manage-leagues": "Gérer les ligues",
    "list": "Liste",
    "calendar": "Calendrier",
    "configuration": "Configuration",
    "schedule": "Calendrier",
    "login": "Connexion",
    "register": "S'inscrire",
    "forgot-password": "Mot de passe oublié",
    "reset-password": "Réinitialiser le mot de passe",
    "error": "Erreur",
    "applications": "Applications",
    "about": "À propos",
    "confirmation": "Confirmation",
    "contact": "Contact",
    "docs": "Docs",
    "knowledge-base": "Base de connaissances",
    "sign-out": "Déconnexion",
    "impersonate": "Incarnation",
    "unimpersonate": "Terminer l'incarnation",
    "recorders": "Enregistreurs",
    "viewer": "Visionner",
    "admin": "Administration",
    "tools": "Outils système"
  },
  "adminTools": {
    "run": "Exécuter",
    "confirm-title": "Confirmer",
    "succeeded": "Réussi",
    "failed": "Échoué",
    "restartJobManager": {
      "title": "Redémarrer le gestionnaire de tâches",
      "description": "Reconstruit les travailleurs et les compteurs du gestionnaire de tâches à partir de la base de données. À utiliser lorsque des tâches terminées sont réessayées sans cesse ou finissent en lettres mortes alors que les travailleurs sont en bon état.",
      "confirm": "Redémarrer le gestionnaire de tâches pour la région sélectionnée? Les tâches déjà assignées continuent de s'exécuter.",
      "region": "Région",
      "all-regions": "Toutes les régions"
    }
  },
  "schedule": {
    "events": "Événements",
    "state": "État",
    "recordings": "Enregistrements",
    "add-new-title": "Ajouter un nouvel enregistrement",
    "sport": "Sport",
    "date": "Date",
    "start-time": "Début",
    "end-time": "Fin",
    "team": "Équipe",
    "recordingSetup": "Configuration",
    "hudlEvent": "Événement programmé",
    "hudlCategory": "Catégorie",
    "includeReplayEvent": "Rendre disponible dans BoothPilot Replay",
    "hudlShare": "Partager avec",
    "liveBroadcast": "Diffuser l'événement en direct",
    "liveBroadcastYoutube": "Diffuser l'événement en direct sur YouTube",
    "end": "Fin",
    "start": "Début",
    "eventName": "Nom de l'événement",
    "opponentTeam": "Équipe adverse",
    "homeTeam": "Équipe à domicile",
    "videoPrivacy": "Visibilité",
    "summary": "Résumé",
    "details": "Détails",
    "videos": "Vidéos",
    "cancel-confirm-message": "Voulez-vous vraiment annuler cet enregistrement ?",
    "end-confirm-message": "Voulez-vous vraiment mettre fin à cet enregistrement ?",
    "end-recording": "Terminer maintenant",
    "add-10-minutes": "Ajouter 10 minutes",
    "logs": "Journaux",
    "recordingJobs": "Tâches d'enregistrement",
    "scoreboard": "Tableau de bord",
    "rtmpBroadcastLink": "Lien RTMP (avec la clé de diffusion)",
    "youtubeBroadcastKey": "Clé de diffusion YouTube (pour diffuser vers un événement existant au lieu d'en créer un nouveau)",
    "vidswapType": "Type",
    "past-date-warning": "La date et l'heure sélectionnées sont dans le passé. L'enregistrement utilisera la sauvegarde au mieux des efforts; les sauvegardes peuvent causer des glitchs dans le résultat.",
    "filter-mismatch": "Cet enregistrement vient d'être créé mais ne correspond pas aux filtres actuels.",
    "start-filter": {
      "7-days-ago": "7 derniers jours",
      "today-only": "Aujourd'hui",
      "today-to-infinity": "À venir",
      "next-7-days": "7 jours à venir"
    },
    "start-filter-label": "Date",
    "state-filter-label": "Exclure statut",
    "privacy": {
      "public": "Public",
      "unlisted": "Non répertorié",
      "private": "Privé"
    },
    "endTimeRequired": "L'heure de fin est requise",
    "endTimeAfterStart": "L'heure de fin doit être après l'heure de début",
    "hudlEmptyWarning": "La vidéo ne sera pas téléversée vers Hudl si laissé vide",
    "datepickerPlaceholder": "Sélecteur de date"
  },
  "manage": {
    "users": "Utilisateurs",
    "teams": "Équipes",
    "organizations": "Organisations",
    "leagues": "Ligues"
  },
  "league": {
    "name": "Nom",
    "enabled": "Activée",
    "sport": "Sport",
    "level": "Catégorie",
    "rseqLeagueId": "ID de la ligue RSEQ",
    "spordleId": "ID Spordle",
    "spordleOfficeId": "ID Office Spordle",
    "spordleUrl": "URL Spordle",
    "includePostSeason": "Inclure les séries éliminatoires dans l'enregistrement",
    "timezone": "Fuseau horaire",
    "submit": "Enregistrer",
    "gender": "Genre",
    "gameDuration": "Durée du match"
  },
  "impersonate":{
    "user": "Utilisateur"
  },
  "state": {
    "recordings":{
      "submitted": "Soumis",
      "scheduled": "Planifié",
      "recording": "En cours d'enregistrement",
      "processing": "Traitement en cours",
      "completed": "Terminé",
      "cancelled": "Annulé",
      "error": "Erreur"
    }
  },
  "listAction":{
    "delete": "Supprimer",
    "cancel": "Annuler",
    "new": "AJOUTER UN NOUVEAU",
    "loadPracticePlan": "CHARGER UN PLAN D'ENTRAÎNEMENT"
  },
  "practicePlan":{
    "title": "Charger le plan d'entraînement",
    "untitledEvent": "Sans titre",
    "untitledPractice": "Entraînement {{n}}",
    "commonAttributes": "Attributs communs",
    "planSettings": "Paramètres du plan",
    "file": "Fichier du plan",
    "fileFormat": "PDF ou Excel",
    "selectTeamFirst": "Sélectionner une équipe pour activer le téléversement.",
    "uploading": "Téléversement…",
    "parsing": "Analyse…",
    "loadPlan": "Charger le plan",
    "bufferBefore": "Tampon avant (min)",
    "bufferAfter": "Tampon après (min)",
    "categoriesIncluded": "Catégories incluses",
    "categoriesHint": "Cliquer pour basculer. Les catégories exclues sont retirées immédiatement.",
    "practicesHeading": "Entraînements ({{count}}) — enregistrements au total : {{total}}",
    "practiceNumberDate": "Date de l'entraînement {{n}}",
    "practiceDateRequired": "La date de l'entraînement est requise",
    "removePractice": "Retirer l'entraînement",
    "noRowsForPractice": "Aucune entrée pour cet entraînement. Cliquer Ajouter une entrée ci-dessous (date d'entraînement requise).",
    "mergeWithNext": "Fusionner avec le suivant",
    "addRow": "Ajouter une entrée",
    "addPractice": "Ajouter un entraînement",
    "createRecording": "Créer {{count}} enregistrement",
    "createRecordings": "Créer {{count}} enregistrements",
    "row": {
      "start": "Début",
      "end": "Fin",
      "configuration": "Configuration",
      "eventName": "Nom de l'événement",
      "buffersLabel": "Tampon avant / après (min)",
      "resetToDefault": "Remettre par défaut",
      "remove": "Retirer",
      "startRequired": "Le début est requis",
      "endRequired": "La fin est requise",
      "endAfterStart": "La fin doit être après le début",
      "configurationRequired": "La configuration est requise",
      "eventNameRequired": "Le nom de l'événement est requis"
    },
    "errors": {
      "selectTeamFirst": "Sélectionner une équipe avant de charger un plan.",
      "chooseFile": "Veuillez choisir un fichier.",
      "failedToParse": "Échec d'analyse du plan d'entraînement.",
      "pickPracticeDate": "Choisir une date d'entraînement avant d'ajouter des entrées.",
      "exceedsMax": "Le plan dépasse {{max}} événements. Retirés — {{dropped}}. Filtrer des catégories pour respecter la limite.",
      "reincludedDropped": "{{count}} événement(s) ré-inclus appartenaient à des entraînements retirés et n'ont pas été restaurés. Recharger le plan pour les récupérer.",
      "unsupportedFile": "Type de fichier non supporté. Utiliser PDF ou Excel (xlsx).",
      "fileTooLarge": "Fichier trop volumineux. Max {{mb}} MB.",
      "uploadFailed": "Échec du téléversement ({{status}})",
      "teamRequired": "L'équipe est requise",
      "dedupedAtSubmit": "{{count}} événement(s) ignoré(s) — même configuration et même heure de début/fin qu'un autre événement de cette soumission : {{names}}"
    }
  },
  "setupPreview": {
    "toggle": "Aperçu",
    "show": "Afficher l'aperçu de la configuration",
    "hide": "Masquer l'aperçu de la configuration",
    "selectConfiguration": "Sélectionnez une configuration pour voir son aperçu.",
    "loading": "Chargement de l'aperçu…",
    "unavailable": "Aucun aperçu disponible pour cette configuration.",
    "noImage": "aperçu non disponible"
  },
  "pages": {
    "add-new": "AJOUTER UN NOUVEAU",
    "add-new-modal-title": "Ajouter un nouvel élément",
    "display-options": "Options d'affichage",
    "orderby": "Trier par : ",
    "product-name": "Nom du produit",
    "category": "Catégorie",
    "description": "Description",
    "status": "Statut",
    "cancel": "Annuler",
    "submit": "Soumettre",
    "delete": "Supprimer",
    "move": "Déplacer",
    "action": "Action",
    "another-action": "Autre action",
    "actions": "ACTIONS",
    "header": "En-tête",
    "details": "DÉTAILS",
    "orders": "COMMANDES",
    "rating": "Évaluation",
    "price": "Prix",
    "is-vegan": "Végétalien",
    "order-status": "Statut de la commande",
    "bake-progress": "Progression de la cuisson",
    "popularity": "Popularité",
    "comments": "Commentaires",
    "error-title": "Oups... une erreur s'est produite !",
    "error-code": "Code d'erreur",
    "go-back-home": "RETOURNER À LA PAGE D'ACCUEIL",
    "no-access-title": "Vous n'avez pas accès à cette application",
    "no-access-message": "Votre compte n'est associé à aucune équipe dans cette application. Contactez votre administrateur si vous croyez qu'il s'agit d'une erreur.",
    "signed-out-title": "Vous avez été déconnecté",
    "signed-out-message": "Vous pouvez vous reconnecter en tout temps, ou retourner à la page d'accueil.",
    "signed-out-sign-in": "Se reconnecter",
    "invoice-info": "Le modèle de facture dispose d'une version en ligne avec des styles intégrés pour une utilisation en dehors du projet, ainsi qu'une version Angular.",
    "angular-version": "Version Angular",
    "inline-version": "Version HTML avec styles intégrés",
    "mailing-info": "Les modèles de courrier utilisent des styles intégrés et une disposition en tableau pour s'afficher correctement sur divers fournisseurs de services. Pour une meilleure convivialité, nous l'incluons sous forme de code HTML régulier avec dangerouslySetInnerHTML.",
    "like": "J'aime",
    "likes": "J'aime",
    "details-title": "Détails",
    "comments-title": "Commentaires",
    "questions-title": "Questions",
    "similar-projects": "Projets similaires",
    "send": "Envoyer",
    "addComment": "Ajouter un commentaire",
    "location": "Emplacement",
    "contact": "Contact",
    "responsibilities": "Responsabilités",
    "photos": "Photos",
    "who-to-follow": "Qui suivre",
    "follow": "SUIVRE",
    "followers": "ABONNÉS",
    "recent-posts": "Publications récentes",
    "profile": "PROFIL",
    "friends": "AMIS",
    "images": "IMAGES",
    "purchase": "ACHETER",
    "view-all": "Voir tout",
    "prices":{
      "developer": "DÉVELOPPEUR",
      "team": "ÉQUIPE",
      "enterprise": "ENTREPRISE",
      "twofactorauthentication": "Authentification à deux facteurs",
      "teampermissions": "Permissions d'équipe",
      "245Support": "Assistance 24/5",
      "247Support": "Assistance 24/7",
      "useractionsauditlog": "Journal des actions de l'utilisateur",
      "featurecomparison" : "Comparaison des fonctionnalités",
      "pricecomparison" : "Comparaison des prix"
    }
  },
  "alert": {
    "success": "Succès",
    "warning": "Avertissement",
    "error": "Erreur",
    "configurationSaveSuccessful": "Configuration enregistrée avec succès",
    "configurationSaveUnsuccessful": "Une erreur est survenue lors de l'enregistrement de la configuration, veuillez réessayer plus tard",
    "tokenRevokeUnsuccessful": "Une erreur est survenue lors de la révocation du jeton. Le jeton a peut-être déjà été révoqué. Vérifiez les autorisations de votre compte pour révoquer manuellement le jeton https://myaccount.google.com/permissions",
    "teamSaveSuccessful": "Équipe enregistrée avec succès",
    "teamSaveUnsuccessful": "Une erreur est survenue lors de l'enregistrement de l'équipe, veuillez réessayer plus tard",
    "organizationSaveSuccessful": "Organisation enregistrée avec succès",
    "organizationSaveUnsuccessful": "Une erreur est survenue lors de l'enregistrement de l'organisation, veuillez réessayer plus tard",
    "leagueSaveSuccessful": "Ligue enregistrée avec succès",
    "leagueSaveUnsuccessful": "Une erreur est survenue lors de l'enregistrement de la ligue, veuillez réessayer plus tard",
    "recordingSaveSuccessful": "Enregistrement mis à jour avec succès",
    "recordingSaveUnsuccessful": "Une erreur est survenue lors de la mise à jour de l'enregistrement, veuillez réessayer plus tard",
    "scoreboardSaveSuccessful": "Tableau de bord mis à jour avec succès",
    "scoreboardSaveUnsuccessful": "Une erreur est survenue lors de la mise à jour du tableau de bord, veuillez réessayer plus tard",
    "addUserToOrganizationFailed": "Une erreur est survenue lors de l'ajout du membre à votre organization, veuillez réessayer plus tard",
    "ptzCalibStarted": "Calibration PTZ ajoutée à la queue",
    "focusCalibStarted": "Calibration du focus ajoutée à la queue",
    "copiedToClipboard": "Copié dans le presse-papier"
  },
  "notifications":{
    "no-notification": "Vous n'avez aucune notification récente"
  },
  "time-ago":{
    "a-few-seconds": "il y a quelques secondes",
    "a-minute-ago": "il y a une minute",
    "minutes-ago": "il y a {{minutes}} minutes",
    "an-hour-ago": "il y a une heure",
    "hours-ago": "il y a {{hours}} heures",
    "a-day-ago": "il y a un jour",
    "days-ago": "il y a {{days}} jours",
    "a-month-ago": "il y a un mois",
    "months-ago": "il y a {{months}} mois",
    "a-year-ago": "il y a un an",
    "years-ago": "il y a {{years}} ans"
  },
  "jumbotron": {
    "hello-world": "Bonjour, le monde !",
    "lead": "Il s'agit d'un simple composant de style jumbotron pour attirer l'attention sur du contenu ou des informations en vedette.",
    "lead-detail": "Il utilise des classes utilitaires pour la typographie et les espacements afin de mieux organiser le contenu dans le conteneur plus grand.",
    "learn-more": "En savoir plus"
  },
  "modal": {
    "close": "Fermer",
    "confirm-message": "Voulez-vous confirmer ?",
    "yes": "Oui",
    "no": "Non",
    "cancel": "Annuler",
    "submit": "Soumettre",
    "add": "Ajouter"
  },
  "privacyOptions": {
    "public": "Public",
    "private": "Privé",
    "unlisted": "Non répertorié"
  },
  "recorder":{
    "active": "Actif",
    "name": "Nom",
    "publicSSHKey": "Clé SSH publique",
    "status": "Statut",
    "remoteSSHPort": "Port SSH distant",
    "outboundSSHPort": "Port SSH sortant",
    "submit": "Sauvegarder",
    "start-ssh": "Débuter une session SSH",
    "stop-ssh": "Compléter la session SSH",
    "get-app-logs": "Obtenir les journaux de l'app",
    "get-camera-logs": "Obtenir les journaux caméra",
    "logs": "Journaux",
    "app-logs": "Journaux de l'application",
    "camera-logs": "Journaux système de la caméra",
    "download": "Télécharger",
    "logs-requested": "Capture des journaux demandée"
  },
  "annotations": {
    "showCoordinates": "Montrer les coordonées"
  },
  "livestreamProvider": {
    "rtmp": "Générique - RTMP"
  },
  "yes": "Oui",
  "no": "Non",
  "youtubeRemoved": "Vidéo supprimée ou accès au compte révoqué",
  "men": "Hommes",
  "women": "Femmes",
  "coed": "Mixte",
  "search": "Rechercher",
  "is-required": "est requis",
  "is-invalid": "est invalide",
  "add-email": "Ajouter le courriel",
  "recipient-user-or-email": "Sélectionner un membre ou saisir une adresse courriel",
  ":": " :",
  "none": "Aucun",
  "all-feminin": "Toutes",
  "error": "Erreur",
  "done": "Complété",
  "password-reset-sent": "Si un compte existe avec cette adresse e-mail, un e-mail de réinitialisation de mot de passe sera envoyé. Utilisez le lien reçu pour réinitialiser votre mot de passe!",
  "password-reset-completed": "Réinitialisation du mot de passe terminée, vous serez redirigé(e) vers la page de connexion!",
  "password-requirements": "Le mot de passe doit contenir au moins 8 caractères, dont 1 lettre majuscule et 1 caractère spécial.",
  "password-reset-invalid-link": "Lien de réinitialisation du mot de passe invalide, veuillez essayer de soumettre à nouveau le formulaire de mot de passe oublié",
  "password-reset-expired": "Lien de réinitialisation de mot de passe expiré, veuillez vérifier vos e-mails pour obtenir un nouveau lien",
  "password-set-expired": "Lien de configuration du mot de passe expiré, veuillez vérifier vos e-mails pour obtenir un nouveau lien",
  "password-reset-completed-app": "Votre mot de passe a été mis à jour. Retournez dans l'application BoothPilot Replay et connectez-vous avec votre nouveau mot de passe.",
  "password-reset-app-open": "Ouvrir l'application Replay",
  "password-reset-app-expired": "Ce lien de réinitialisation est expiré. Demandez-en un nouveau depuis l'application BoothPilot Replay et réessayez.",
  "password-reset-app-invalid": "Ce lien de réinitialisation n'est plus valide — il a peut-être déjà été utilisé. Demandez-en un nouveau depuis l'application BoothPilot Replay.",
  "auth-action-verifying": "Vérification de votre courriel...",
  "auth-action-verified-title": "Courriel vérifié",
  "auth-action-verified-body": "Votre adresse est confirmée. Si vous étiez en train de créer un compte dans l'application BoothPilot Replay, retournez-y et touchez « J'ai vérifié mon courriel ».",
  "auth-action-error-title": "Impossible de vérifier ce lien",
  "auth-action-expired": "Ce lien de vérification est expiré. Demandez-en un nouveau depuis l'application et réessayez.",
  "auth-action-invalid": "Ce lien n'est plus valide — il a peut-être déjà été utilisé. Si la vérification a déjà eu lieu, tout est en ordre.",
  "does-not-match": "ne correspond pas",
  "errorMessages": {
    "title": "Erreur",
    "recording-not-found": "Enregistrement introuvable.",
    "recording-not-ready": "L'enregistrement n'est pas encore prêt.",
    "recording-deleted": "Cet enregistrement a été supprimé parce que sa période de conservation a expiré.",
    "team-not-found": "Lien d'équipe invalide.",
    "recording-private-login-required": "Cet enregistrement est privé. Vous devez être connecté pour le voir.",
    "recording-private-no-team": "Cet enregistrement est privé et n'est associé à aucune équipe.",
    "recording-unlisted-no-team": "Cet enregistrement est non répertorié et n'est associé à aucune équipe.",
    "recording-access-denied": "Vous n'avez pas la permission de voir cet enregistrement.",
    "recording-unlisted-invalid-key": "Le lien de partage est invalide ou a expiré.",
    "unkonwn-error": "Une erreur inattendue est survenue."
  },
  "team-recordings": {
    "title": "Enregistrements d'équipe",
    "filter-days": {
      "7": "7 Jours",
      "30": "30 Jours",
      "90": "3 Mois",
      "180": "6 Mois",
      "all": "Tout"
    },
    "alerts": {
      "private-restricted": "Certains enregistrements sont masqués car ils sont privés.",
      "private-restricted-ask-login-1": "Connectez-vous",
      "private-restricted-ask-login-2": "pour les voir.",
      "unlisted-restricted": "Certains enregistrements sont masqués car vous n'avez pas de lien de partage valide.",
      "no-access": "Aucun enregistrement disponible.",
      "empty-filter": "Aucun enregistrement trouvé pour cette période."
    },
    "status": {
      "ready": "Prêt",
      "deleted": "Supprimé",
      "processing": "Traitement"
    },
    "team-list": {
      "title": "Mes Équipes",
      "no-teams": "Vous n'êtes pas membre d'aucune équipe."
    }
  }
}
